import { PasswordWithConfirmationModel } from '@goparrot-dashboard-api/auth';
import { useEntityForm, ValidationStrategyEnum } from '@goparrot-dashboard/entity-form';
import { useI18n } from '@goparrot-dashboard/i18n';
import { Form } from '@goparrot-dashboard/shared-ui';
import * as React from 'react';

import { MarketButton } from '@market/react-bindings';
import { ENTER_KEY } from '../constants';
import { PasswordWithConfirmationFormSegment } from './segments/PasswordWithConfirmationFormSegment';

type SetupPasswordFormProps = {
  onSubmit(payload: PasswordWithConfirmationModel): void;
  isFormLoading?: boolean;
  buttonText?: string;
};
export const SetupPasswordForm: React.FC<React.PropsWithChildren<SetupPasswordFormProps>> = ({ onSubmit, isFormLoading, buttonText }) => {
  const { getIntlString } = useI18n();

  const form = useEntityForm<PasswordWithConfirmationModel>({
    model: PasswordWithConfirmationModel,
    validationStrategy: ValidationStrategyEnum.onSave,
    initialState: {
      password: '',
      repeatPassword: '',
    },
  });

  const onFormSubmit: React.FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    form.onSubmit(onSubmit);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLFormElement>) => {
    if (e.key === ENTER_KEY) {
      onFormSubmit(e);
    }
  };

  return (
    <Form onSubmit={onFormSubmit} onKeyDown={handleKeyDown}>
      <PasswordWithConfirmationFormSegment<PasswordWithConfirmationModel> form={form} />
      <MarketButton
        rank="primary"
        isLoading={isFormLoading || undefined}
        disabled={isFormLoading || (form.isDirtyForm && !form.isFormValid) || undefined}
        type="submit"
        className="tw-w-full tw-mt-5"
      >
        {buttonText || getIntlString('button.resetPassword')}
      </MarketButton>
    </Form>
  );
};
